import * as Utilities from './utilities';

export const VuexOrmExtensions = {
    Utilities
};
